import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LiatActivationFormComponent } from './components/liat-activation-form/liat-activation-form.component';

const routes: Routes = [{ path: '', component: LiatActivationFormComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LiatActivationRouterModule {
}